// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';
import { INDIA_STATES } from '@tectonics/prs/india/constants';

export function validateIndiaState(stateValue: string): ?UserInputValidationError {
  if (!stateValue || stateValue.length === 0) {
    return { id: 'empty' };
  } else if (!validStateValue(stateValue)) {
    return { id: 'invalid-state' };
  }
}

function validStateValue(stateValue: string): boolean {
  return INDIA_STATES.find((data) => data.code.toUpperCase() === stateValue.toUpperCase()) !== undefined;
}
